/** Shared external destinations */
export const CUSTOMER_PORTAL_URL = 'https://portal.gnbank.net';

export const Enroll_link = "https://podd.robo.secureinternetbank.com/PBI_PBI1151/Enroll/271070924"